export enum RoleProps  {
    'User',
    'ClientAdmin',
    'Admin'
  }
  export default RoleProps;